import { createContext, useEffect, useReducer, useContext } from "react";
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";
import { getPageLayoutType } from '../../../common/utils/utilsFunc';
import { AccessTokenContext } from "../../../common/context/AccessTokenProvider";

export const NumberAssociatedCustomersContext = createContext();
export const ACTIONS = {
    SET_WEB_CONTENT_TEXT_INFO: "SET_WEB_CONTENT_TEXT_INFO",
    SET_WEB_CONTENT_TEXT_READ_MORE: "SET_WEB_CONTENT_TEXT_READ_MORE",
    SET_IDLIST: "SET_IDLIST",
    SET_ERROR: "SET_ERROR",
    SET_CTA_CTO: "SET_CTA_CTO",
    SET_DETAIL_CLIENT: "SET_DETAIL_CLIENT",
    SET_FORM: "SET_FORM",
    SET_FORM_RESPONSE: "SET_FORM_RESPONSE"

};
const initialState = {
    webContentTextInfo: "",
    webContentTextReadMore: "",
    idList: "",
    error: "",
    ctaCto: "",
    detailClient: "",
    form:"",
    formResponse:"",
    relations:""

};
const NumberAssociatedCustomersReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_FORM_RESPONSE: {
      return {
        ...state,
        formResponse: action.payload,
      };
    }
    case ACTIONS.SET_FORM: {
      return {
        ...state,
        form: action.payload,
      };
    }
    case ACTIONS.SET_DETAIL_CLIENT: {
      return {
        ...state,
        detailClient: action.payload,
      };
    }
    case ACTIONS.SET_CTA_CTO: {
      return {
        ...state,
        ctaCto: action.payload,
      };
    }
    case ACTIONS.SET_IDLIST: {
      return {
        ...state,
        idList: action.payload,
      };
    }
    case ACTIONS.SET_WEB_CONTENT_TEXT_INFO: {
      return {
        ...state,
        webContentTextInfo: action.payload,
      };
    }
    case ACTIONS.SET_WEB_CONTENT_TEXT_READ_MORE: {
      return {
        ...state,
        webContentTextReadMore: action.payload,
      };
    }
    case ACTIONS.SET_RELATIONS: {
      return {
        ...state,
        relations: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
const NumberAssociatedCustomersContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);

  const [state, dispatch] = useReducer(NumberAssociatedCustomersReducer, initialState);

  const { accessToken } = useContext(AccessTokenContext);

  useEffect(() => {
    if (properties?.webcontent_info_page_number_associated_customers && (properties?.webcontent_info_page_number_associated_customers).trim()) {
        LiferayService.getWebContent(properties.base_url_api, (properties?.webcontent_info_page_number_associated_customers).trim())
          .then((response) => {
            dispatch({
              payload: response,
              type: ACTIONS.SET_WEB_CONTENT_TEXT_INFO,
            });
          })
    }

    if ((properties?.webcontent_read_more_page_number_associated_customers).trim()) {
        LiferayService.getWebContent(properties.base_url_api, (properties?.webcontent_read_more_page_number_associated_customers).trim())
          .then((response) => {
            dispatch({
              payload: response,
              type: ACTIONS.SET_WEB_CONTENT_TEXT_READ_MORE,
            });
          })
    }

    LiferayService.getRelationctacto(properties.base_url_api)
      .then((response) => {
        dispatch({
          payload: response,
          type: ACTIONS.SET_RELATIONS,
        });
      })

  }, []);

  useEffect(() => {
    if(!state?.idList && accessToken)
    LiferayService.getIdList(properties.base_url_api)
      .then((response) => {
        dispatch({
          payload: null,
          type: ACTIONS.SET_ERROR,
        });
        dispatch({
          payload: response,
          type: ACTIONS.SET_IDLIST,
        });
      })
      .catch((error) => {
        dispatch({
          payload: error,
          type: ACTIONS.SET_ERROR,
        });
      })
  },[accessToken])

  
  useEffect(() => {
    if (state.ctaCto) {
        LiferayService.consultarDetalleCuentaContrato(properties.base_url_api,state.ctaCto, properties.url_ws_empresa, properties.codigo_empresa)
        .then((response) =>{
          dispatch({
              payload: response,
              type: ACTIONS.SET_DETAIL_CLIENT,
          });
        })
      }
  }, [state.ctaCto]);

  
  useEffect(() => {
    if (state.form) {
        LiferayService.sendFormAddNumberAccount(properties.base_url_api,state.form)
        .then((response) =>{
          dispatch({
              payload: response,
              type: ACTIONS.SET_FORM_RESPONSE,
          });
          dispatch({
              payload: "",
              type: ACTIONS.SET_FORM,
          });
        })
      }
  }, [state.form]);

  return (
    <NumberAssociatedCustomersContext.Provider value={[state, dispatch]}>
      {children}
    </NumberAssociatedCustomersContext.Provider>
  );
};
export default NumberAssociatedCustomersContextProvider;
